import type { FC } from "react";
import {
	type ActivityOrTaskListItem,
	isActivityListItem,
} from "web_myplann/Activities/Helpers/isActivityListItem";
import { DashboardActivityRow } from "web_myplann/Dashboard/Components/DashboardActivityRow";
import { DashboardTaskRow } from "web_myplann/Dashboard/Components/DashboardTaskRow";

type Props = {
	item: ActivityOrTaskListItem;
	showDivider: boolean;
};

export const ActivityGroupRow: FC<Props> = ({ item, showDivider }) =>
	isActivityListItem(item) ? (
		<DashboardActivityRow data={item} showDivider={showDivider} />
	) : (
		<DashboardTaskRow data={item} showDivider={showDivider} />
	);
